module.exports = __webpack_public_path__ + "static/image-inspiration-hero-ac2ae8c5f0c575e7125b51024ad4c977.jpg";